import React from 'react'
import { styled, context, Dropdown } from '@tools/wr-catalog-base'
import SortableCart from '@routes/Product/Cart/SortableCart/cart'
import CartIndicator from './cart-indicator'

const Container = styled.div`
  .dropdown-list {
    width: auto !important;
  }
`

export default function CartPopup(props) {
  const { cart } = context.state
  return (
    <Container>
      <Dropdown>
        {({ DropdownTrigger, DropdownList }) => (
          <>
            <DropdownTrigger>
              <CartIndicator />
            </DropdownTrigger>
            <DropdownList>
              <>
                {cart.length ? (
                  <SortableCart cart={cart} isDropdownCart />
                ) : (
                  <div style={{ padding: 15, width: 250 }}>Cart empty</div>
                )}
              </>
            </DropdownList>
          </>
        )}
      </Dropdown>
    </Container>
  )
}
